import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DashedWrapper, DropContainer } from './drag-and-drop.styles';
class DragAndDrop extends Component {
  dropRef = React.createRef();

  static propTypes = {
    handleDroppedFile: PropTypes.func.isRequired,
    fileDropLimit: PropTypes.number.isRequired,
    children: PropTypes.oneOfType([PropTypes.node, PropTypes.elementType])
      .isRequired
  };

  state = {
    dragging: false,
    overFileDropLimit: false
  };

  componentDidMount() {
    this.dragCounter = 0;
    const div = this.dropRef.current;
    div.addEventListener('dragenter', this.handleDragIn);
    div.addEventListener('dragleave', this.handleDragOut);
    div.addEventListener('dragover', this.handleDrag);
    div.addEventListener('drop', this.handleDrop);
  }

  componentWillUnmount() {
    const div = this.dropRef.current;
    div.removeEventListener('dragenter', this.handleDragIn);
    div.removeEventListener('dragleave', this.handleDragOut);
    div.removeEventListener('dragover', this.handleDrag);
    div.removeEventListener('drop', this.handleDrop);
  }

  handleDrag = e => {
    e.preventDefault();
    e.stopPropagation();
  };

  handleDragIn = e => {
    e.preventDefault();
    e.stopPropagation();

    const { fileDropLimit } = this.props;
    this.dragCounter++;
    if (e.dataTransfer.items && e.dataTransfer.items.length > fileDropLimit) {
      this.setState({ overFileDropLimit: true });
    } else if (e.dataTransfer.items && e.dataTransfer.items.length > 0) {
      this.setState({ dragging: true });
    }
  };

  handleDragOut = e => {
    e.preventDefault();
    e.stopPropagation();

    this.dragCounter--;
    if (this.dragCounter > 0) return;
    this.setState({ dragging: false, overFileDropLimit: false });
  };

  handleDrop = e => {
    e.preventDefault();
    e.stopPropagation();

    const { handleDroppedFile, fileDropLimit } = this.props;
    if (
      e.dataTransfer.files &&
      e.dataTransfer.files.length > 0 &&
      e.dataTransfer.files.length <= fileDropLimit
    ) {
      handleDroppedFile(e.dataTransfer.files);
      e.dataTransfer.clearData();
      this.dragCounter = 0;
    }
    this.setState({ dragging: false });
  };

  render() {
    const { dragging, overFileDropLimit } = this.state;
    const { children } = this.props;
    return (
      <DashedWrapper dragging={dragging} ref={this.dropRef}>
        {dragging && !overFileDropLimit && (
          <div
            style={{
              position: 'absolute',
              top: '0',
              left: '0',
              width: '100%',
              height: '100%',
              backgroundColor: 'rgba(255,255,255,.8)'
            }}
          >
            <DropContainer></DropContainer>
          </div>
        )}
        {children}
      </DashedWrapper>
    );
  }
}

export default DragAndDrop;
